import { Undo2 } from "lucide-react";

import { ColocaAlert } from "@/shared/components/feedback/ColocaAlert";
import useTranslations from "@/shared/lang/useTranslations";
import { formatDateTime } from "@/shared/utils/dateTimeHelpers";

export interface BatchReturnedBannerProps {
  reason: string;
  returnedAt: string | null;
}

/** The approver sent the last submission back; the reason stays until the batch is sent again. */
export function BatchReturnedBanner({ reason, returnedAt }: BatchReturnedBannerProps) {
  const { t, activeLanguage } = useTranslations("payoutBatches");

  return (
    <ColocaAlert
      variant="warning"
      icon={Undo2}
      heading={t("returned_banner_title", {
        when: formatDateTime(returnedAt, { locale: activeLanguage, includeTime: true }),
      })}
      text={
        <span className="space-y-1">
          <span className="block font-medium">“{reason}”</span>
          <span className="block">{t("returned_banner_text")}</span>
        </span>
      }
    />
  );
}
